import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavigationBar from '../components/NavigationBar';
import { API_BASE_URL } from '../config/config';
import '../css/TeleMedicine.css';
import '../css/TeleMedicineVideo.css';

const dummyData = [
  {
    id: 1,
    date: '2025.04.24',
    name: '김순자',
    gender: '여',
    age: 66,
    type: '만성질환',
    symptom: '많이 아파요',
    status: '진료중',
    meetingDate: '2025.04.25 9:00',
    record: '감기 증상\n감기약 처방',
  },
  {
    id: 2,
    date: '2025.04.24',
    name: '김문자',
    gender: '여',
    age: 65,
    type: '만성질환',
    symptom: '대기중',
    status: '대기중',
    meetingDate: '2025.04.25 10:00',
    record: '',
  },
  {
    id: 3,
    date: '2025.04.24',
    name: '박철수',
    gender: '남',
    age: 50,
    type: '중증질환',
    symptom: '-',
    status: '대기중',
    meetingDate: '2025.04.25 18:00',
    record: '',
  },
];

const TeleMedicineVideo = () => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(dummyData[0].id);
  const [page, setPage] = useState(1);
  const totalPages = 3;

  return (
    <div className="tmv-container">
      <NavigationBar />
      <div className="tmv-video-area">
        <span className="tmv-video-placeholder">화상 회의의 화면</span>
      </div>
      <div className="tmv-table-wrapper">
        <table className="tmv-table">
          <thead>
            <tr>
              <th>선택</th>
              <th>신청일자</th>
              <th>요청자</th>
              <th>성별</th>
              <th>나이</th>
              <th>요청 구분</th>
              <th>증상</th>
              <th>상태</th>
              <th>진료/회의 일시</th>
              <th>기록</th>
            </tr>
          </thead>
          <tbody>
            {dummyData.map(row => (
              <tr key={row.id}>
                <td>
                  <input
                    type="radio"
                    name="selectRow"
                    checked={selectedId === row.id}
                    onChange={() => setSelectedId(row.id)}
                  />
                </td>
                <td>{row.date}</td>
                <td>{row.name}</td>
                <td>{row.gender}</td>
                <td>{row.age}</td>
                <td>{row.type}</td>
                <td>{row.symptom}</td>
                <td>{row.status}</td>
                <td>{row.meetingDate}</td>
                <td style={{whiteSpace:'pre-line'}}>{row.record}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="tmv-paging">
          {[1,2,3].map(num => (
            <button
              key={num}
              className={`tmv-paging-btn${page===num?' active':''}`}
              onClick={()=>setPage(num)}
            >{num}</button>
          ))}
        </div>
        <div className="tmv-actions">
          <button className="tmv-action-btn">화상회의의 시작</button>
          <button className="tmv-action-btn">화상회의의 종료</button>
        </div>
      </div>
    </div>
  );
};

export default TeleMedicineVideo; 